import React, { useEffect, useState } from 'react';

type CountdownTimerProps = {
  /** Timestamp (ms) at which the countdown ends */
  endTime: number;
  /** Render function receiving the remaining seconds */
  children: (remainingSeconds: number) => React.ReactNode;
};

/**
 * Isolated countdown component.
 * Only this component re-renders every second, not the parent.
 */
export default function CountdownTimer({
  endTime,
  children,
}: CountdownTimerProps): JSX.Element {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.ceil((endTime - Date.now()) / 1000)),
  );

  useEffect(() => {
    setRemaining(Math.max(0, Math.ceil((endTime - Date.now()) / 1000)));

    if (endTime <= Date.now()) return;

    const interval = setInterval(() => {
      const next = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setRemaining(next);
      if (next <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  return <>{children(remaining)}</>;
}
